var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { namespace } from "vuex-class";
import Component from 'vue-class-component';
import { Emit, Prop } from "vue-property-decorator";
import DataBox from '~/components/common/data-box.vue';
import { Dependencies } from '~/core/decorator';
import { TemplateService } from '~/services/domain-service/template.service';
var CollectionExecutionModule = namespace("collection-execution");
import { MENU_CHANNEL } from '~/config/enum.config';
var ContractFormation = /** @class */ (function (_super) {
    __extends(ContractFormation, _super);
    function ContractFormation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.conTractContent = '';
        _this.fromData = {
            templateId: "",
            caseId: _this.caseIds[0]
        };
        _this.dialog = {
            preview: false,
        };
        _this.rules = {
            templateId: [{ required: true, message: "请选择合同名称", trigger: "blur" }]
        };
        _this.dataSet = [];
        _this.templateSet = [];
        return _this;
    }
    ContractFormation.prototype.EmitClose = function () { };
    ContractFormation.prototype.getTemplateByDistributeType = function () {
        var _this = this;
        var distributeType = "";
        switch (this.menuChannel) {
            case MENU_CHANNEL.Tel_personal:
            case MENU_CHANNEL.Tel_team:
                distributeType = "TEL";
                break;
            case MENU_CHANNEL.Visit_personal:
            case MENU_CHANNEL.Visit_team:
                distributeType = "VISIT";
                break;
            case MENU_CHANNEL.Legal_personal:
            case MENU_CHANNEL.Legal_team:
                distributeType = "LEGAL";
                break;
            default:
                break;
        }
        if (distributeType) {
            this.templateService.getTemplateByDistributeType({ distributeType: distributeType }).subscribe(function (data) { return _this.templateSet = data; });
        }
        this.refreshData();
    };
    ContractFormation.prototype.commit = function () {
        this.EmitClose();
    };
    ContractFormation.prototype.onClickContract = function () {
        var _this = this;
        var form = this.$refs["contract-formation-form"];
        form.validate(function (valid) {
            if (!valid)
                return false;
            _this.templateService
                .createContractInfo(_this.fromData)
                .subscribe(function (data) {
                _this.$message.success("操作成功");
                form.resetFields();
                _this.refreshData();
            });
        });
    };
    ContractFormation.prototype.refreshData = function () {
        var _this = this;
        this.templateService.getContractInfoByCaseId(this.caseIds[0]).subscribe(function (data) { return _this.dataSet = data; });
    };
    ContractFormation.prototype.onClickPreview = function (row) {
        this.dialog.preview = true;
        this.conTractContent = row.contractContent;
    };
    ContractFormation.prototype.onClickDownload = function (row) {
        var a = document.createElement("a");
        var attrDownload = document.createAttribute("download");
        attrDownload.value = row.id + ".pdf";
        a.attributes.setNamedItem(attrDownload);
        a.href = row.url + "/" + row.id;
        a.click();
    };
    __decorate([
        CollectionExecutionModule.State
    ], ContractFormation.prototype, "menuChannel", void 0);
    __decorate([
        Dependencies(TemplateService)
    ], ContractFormation.prototype, "templateService", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], ContractFormation.prototype, "caseIds", void 0);
    __decorate([
        Emit('close')
    ], ContractFormation.prototype, "EmitClose", null);
    ContractFormation = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], ContractFormation);
    return ContractFormation;
}(Vue));
export default ContractFormation;
